export const config =
    process.env.ENVIRONMENT === 'PRODUCTION'
        ? {
              Auth: {
                  region: 'us-east-1',
                  userPoolId: 'us-east-1_M5F4gmdk7',
                  userPoolWebClientId: '74bodf0gdn5nmpeefvt9rlkmds',
                  authenticationFlowType: 'USER_PASSWORD_AUTH',
                  oauth: {
                      domain: 'auth.motionengine.app',
                      scope: ['email', 'openid'],
                      redirectSignIn: 'https://portal.exer.ai/home',
                      redirectSignOut: 'https://portal.exer.ai/login',
                      responseType: 'code',
                  },
              },
          }
        : process.env.ENVIRONMENT === 'STAGING'
        ? {
              Auth: {
                  region: 'us-east-1',
                  userPoolId: 'us-east-1_M5F4gmdk7',
                  userPoolWebClientId: '57qflgn9aedpgcjusi2gi4je63',
                  authenticationFlowType: 'USER_PASSWORD_AUTH',
                  oauth: {
                      domain: 'auth.motionengine.app',
                      scope: ['email', 'openid'],
                      redirectSignIn: 'https://provider-staging.motionengine.app/home',
                      redirectSignOut: 'https://provider-staging.motionengine.app/user/login',
                      responseType: 'code',
                  },
              },
          }
        : {
              Auth: {
                  region: 'us-east-1',
                  userPoolId: 'us-east-1_M5F4gmdk7',
                  userPoolWebClientId: '57qflgn9aedpgcjusi2gi4je63',
                  authenticationFlowType: 'USER_PASSWORD_AUTH',
                  oauth: {
                      domain: 'auth.motionengine.app',
                      scope: ['email', 'openid'],
                      redirectSignIn: 'http://localhost:8081/home/',
                      redirectSignOut: 'http://localhost:8081/user/login/',
                      responseType: 'code',
                  },
              },
          };
